import { LoadablePaint } from '@confluence/loadable';

export const RecommendedPageBanner = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-RecommendedPageBanner" */ '../src/RecommendedPageBanner.tsx'
		).then((module) => module.RecommendedPageBanner),
});

export type { RecommendedPageBannerProps } from '../src/RecommendedPageBanner.tsx';
